<template>
  <div>
    <page :slugs="slugs" :post="post" />
  </div>
</template>

<script>
import page from '~/marketplace-front-core/pages/cms/postPage'
export default {
  name: 'PageCmsPostPage',
  components: { page },
  async asyncData ({ app, params, redirect }) {
    const post = await app.$api.cms.url({ url: params.slug })
      .then((res) => {
        if (res && res.description && res.lang && res.lang === app.store.state.i18n.locale) {
          return res
        } else if (res && res.type && res.type === 'TYPE_POST') {
          return redirect(app.localePath('cms-blog'))
        } else {
          return redirect(app.localePath('index'))
        }
      })
      .catch(() => { return redirect(app.localePath('index')) })
    const slugs = post ? post.slugs : null
    if (post && post.url && post.lang) {
      slugs.push({ lang: post.lang, url: post.url })
    }
    return { post, slugs }
  }
}
</script>
